module.exports = __webpack_public_path__ + "img/icon_link.39c32537.svg";